import type { MyCollectionPageConfig } from '@/app/(football)/[team]/my-collection/_context/types';

export const fcanyangConfig: MyCollectionPageConfig = {};
